<template>
    <div class="main-page">
      <!-- 查询条件 -->
      <el-form :model="queryForm" ref="queryForm" label-width="80px">
        <el-form-item label="Search">
          <el-input v-model="queryForm.search" placeholder="Enter search query"></el-input>
        </el-form-item>
        <el-button type="primary" @click="submitQuery">Search</el-button>
      </el-form>
  
      <!-- 下半部分分为左右两个部分 -->
      <div class="row">
        <!-- 左侧表格 -->
        <div class="table">
          <el-table :data="tableData" style="width: 100%;">
            <!-- 表格的列配置 -->
            <el-table-column prop="column1" label="Column 1"></el-table-column>
            <el-table-column prop="column2" label="Column 2"></el-table-column>
            <!-- 添加更多列 -->
          </el-table>
        </div>
  
        <!-- 右侧雷达图 -->
        <div class="radar-chart">
          <!-- 雷达图的内容放在这里 -->
          <!-- 例如，你可以使用第三方雷达图库来绘制雷达图 -->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        queryForm: {
          search: '',
        },
        tableData: [],
      };
    },
    methods: {
      submitQuery() {
        // 处理查询逻辑
      },
    },
    created() {
      // 初始化数据
      // ...
    },
  };
  </script>
  
  <style scoped>
  /* 添加 Element UI 的样式规则 */
  /* 你可以根据需要自定义 Element UI 组件的样式 */
  </style>
  